/**
 * Location alias lookup for the group finder search.
 * Keys are lowercase; callers must normalise with .toLowerCase() before lookup.
 * Only unambiguous, single-target mappings are included.
 *
 * Used by filter-bar.tsx (client) and app/api/search/route.ts (server).
 */
export const LOCATION_ALIASES: Record<string, string> = {
  // ── South African province codes (ISO 3166-2:ZA) ──────────────────────────
  kzn: "KwaZulu-Natal",
  wc: "Western Cape",
  gp: "Gauteng",
  ec: "Eastern Cape",
  nc: "Northern Cape",
  nw: "North West",
  mp: "Mpumalanga",
  lp: "Limpopo",
  fs: "Free State",

  // ── Johannesburg ───────────────────────────────────────────────────────────
  joburg: "Johannesburg",
  jozi: "Johannesburg",
  jhb: "Johannesburg",

  // ── Other city abbreviations ───────────────────────────────────────────────
  dbn: "Durban",
  pmb: "Pietermaritzburg",
  pta: "Pretoria",
  // Official metro name is Tshwane but most groups are stored under "Pretoria"
  tshwane: "Pretoria",
  el: "East London",
  bloem: "Bloemfontein",
  // City renamed Port Elizabeth → Gqeberha (2021). Mapbox now uses "Gqeberha".
  // nearbyItems geographic fallback covers any DB records still on the old name.
  pe: "Gqeberha",
  "port elizabeth": "Gqeberha",

  // ── Country abbreviations (supersedes COUNTRY_ALIASES in route.ts) ─────────
  za: "South Africa",
  rsa: "South Africa",
  sa: "South Africa",
  zw: "Zimbabwe",
  zim: "Zimbabwe",
  mw: "Malawi",
  moz: "Mozambique",
};
